import { theme } from '..'

export const useTheme = () => theme
